import request from '../utils/request';

const url = 'scenic-spot/feedBack';

export function add(feedback: any): Promise<any> {
  return new Promise<any>((resolve, reject) => {
    request({
      url: `${url}`,
      method: 'post',
      data: feedback
    }).then((res) => resolve(res.data)).catch((err) => reject(err));
  });
}
